import React from "react";

// hooks
import useKakaoChannel from "../../hooks/useKakaoChannel";

const NoPartner = () => {
  const { handleClickOpenKakao } = useKakaoChannel();

  return (
    <div className="body">
      <div className="no-partner">
        <p>강사님으로 등록된 센터가 없어요</p>
        <span>
          사용을 원하시면 대표관리자에게 <br /> 먼저 문의해주세요!
        </span>
        <button onClick={handleClickOpenKakao}>바디코디 문의하기</button>
      </div>
    </div>
  );
};

export default NoPartner;
